import React from "react";

interface PlainTextMessageBodyProps {
	children?: React.ReactNode;
}

function convertToPlainText(html: string): string {
	try {
		const htmlWithLinebreaks = html.replace(/<br\s*\/?>/gi, "\n");
		const parser = new DOMParser();
		const doc = parser.parseFromString(htmlWithLinebreaks, "text/html");
		const text = doc.body.textContent;
		return text ? text.trim() : html;
	} catch {
		return html.replace(/<[^>]+>/g, "").trim();
	}
}

export default function PlainTextMessageBody({
	children,
}: PlainTextMessageBodyProps) {
	const isString = typeof children === "string" || children instanceof String;
	if (!isString) {
		return <div />;
	}

	return <div>{convertToPlainText(String(children))}</div>;
}
